import { render, staticRenderFns } from "./inventory-with-pos.vue?vue&type=template&id=fa3020ee"
import script from "./inventory-with-pos.vue?vue&type=script&lang=js"
export * from "./inventory-with-pos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports